import React, { useEffect, useState } from "react";
import { Col, Container, ListGroup, Row } from "react-bootstrap";

// css
import styles from "./addForm.module.scss";
import { generatePath, Link, useNavigate, useParams } from "react-router-dom";
import { WORKSHOP_EDIT, WORKSHOPS } from "config/paths";
import { Breadcrumbs, RequiredFieldAstrick } from "components/Common/Common";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { dateFormat, userFullName } from "helpers/common";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { useWorkshopViewQuery } from "store/services/workshop";
import parse from 'html-react-parser';
import moment from "moment";
import { useSelector } from "react-redux";
import { User } from "react-feather";


const WorkshopView = () => {

    const navigate = useNavigate();
    const { id: workshopId } = useParams();
    const profile = useSelector((state) => state?.auth?.user)
    const [isOwner, setIsOwner] = useState(false);

    const breadcrumbItems = [
        { label: "Workshops", path: WORKSHOPS },
        { label: "View" },
    ];

    const { data: workshopData, isFetching: workshopDataFetching } = useWorkshopViewQuery({ workshopId }, { skip: !workshopId })

    useEffect(() => {
        if (workshopData) {
            workshopData?.workshopOwner?.id != profile?.id ? setIsOwner(false) : setIsOwner(true)
        }
    }, [workshopData])

    return (
        <>
            <section className={`${styles.addForm} position-relative py-4 addForm h-100`}>
                <Container className="h-100">

                    <Row className="">
                        <Col lg="6">
                            <Breadcrumbs items={breadcrumbItems} />
                        </Col>
                    </Row>
                    {(workshopDataFetching) ? <LoadingIndicator /> : <Row className="h-100">
                        <Col lg="12" className="my-2">
                            <div className="reports-v2">
                                <div className=" d-flex align-items-center justify-content-between" style={{ borderColor: "#315D99" }}>
                                    {/* <h6 className="mb-0 section-title border-bottom-0" style={{ color: "#315D99" }}>{editMode ? "Edit TEMPLATES" : "SAVE A TEMPLATES"}</h6> */}
                                </div>
                                <Row >
                                    <Col md="12" className="my-2 name-input-v2">
                                        <div style={{ borderBottom: "2px solid gray" }} className="pb-3 d-flex align-items-end gap-5">
                                            <h2 className="w-100">{workshopData?.title}</h2>
                                            <div className="btnWrpper mt-2 d-flex justify-content-end">
                                                {
                                                    isOwner && <button
                                                        type="button"
                                                        className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                                        onClick={() => navigate(generatePath(WORKSHOP_EDIT, { id: workshopId }))}
                                                        disabled={workshopDataFetching}
                                                    // isLoading={submitReportLoading || submitting}
                                                    >
                                                        Edit
                                                    </button>
                                                }
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md="6" className="my-2 name-input-v2">
                                        <label
                                            htmlFor=""
                                            className="discharge-screen-label mt-0"
                                        >
                                            Link
                                            <RequiredFieldAstrick />
                                        </label>
                                        <Link to={workshopData?.link} target="_blank" >
                                            <p>{workshopData?.link || "--"}</p>
                                        </Link>
                                    </Col>
                                    <Col md="3" className="my-2 name-input-v2">
                                        <label
                                            htmlFor=""
                                            className="discharge-screen-label mt-0"
                                        >
                                            Date Created
                                            <RequiredFieldAstrick />
                                        </label>
                                        <p>{moment(workshopData?.date).isValid() ? dateFormat(workshopData?.date, "MMM DD, YYYY") : "--"}</p>
                                    </Col>
                                    <Col md="6" className="mt-2">
                                        <label
                                            htmlFor=""
                                            className="discharge-screen-label mt-0"
                                        >
                                            Description
                                            <RequiredFieldAstrick />
                                        </label>
                                        <div className="editor-paren-v2">
                                            {parse(workshopData?.description || "")}
                                        </div>
                                    </Col>

                                    <Col md="4" className="mt-2">
                                        <div style={{ borderTop: "1px solid rgb(94 122 162)", paddingTop: "23px" }} className="editor-paren-v2">
                                            <div style={{ width: "250px" }}>
                                                <h6 className="mb-3 fw-semibold">Owner</h6>

                                                <div className="d-flex mb-3 gap-2 align-items-center">
                                                    {
                                                        workshopData?.workshopOwner?.therapist_detail?.profile_picture ? 
                                                        <img
                                                            src={workshopData?.workshopOwner?.therapist_detail?.profile_picture}
                                                            alt=""
                                                            className="img-fluid object-fit-cover rounded-circle border border-white"
                                                            style={{ width: 30, height: 30 }}
                                                        /> : <User size={24} className="text-secondary" />
                                                    }
                                                    <span>{userFullName(workshopData?.workshopOwner)}</span>

                                                </div>
                                                <h6 className="mb-3 fw-semibold">Collaborators</h6>
                                                <ListGroup variant="flush">
                                                    {workshopData?.collaborators?.map((item, index) => (
                                                        <ListGroup.Item key={index} className="border-0 px-0 py-2">
                                                            <table className="w-100">
                                                                <tbody>
                                                                    <tr>
                                                                        {/* User info */}
                                                                        <td className="align-middle">
                                                                            <div className="d-flex align-items-center gap-2">
                                                                                {(item?.user?.therapist_detail?.profile_picture ||
                                                                                    item?.therapist_detail?.profile_picture) ? (
                                                                                    <img
                                                                                        src={
                                                                                            item?.user?.therapist_detail?.profile_picture ||
                                                                                            item?.therapist_detail?.profile_picture
                                                                                        }
                                                                                        alt=""
                                                                                        className="img-fluid object-fit-cover rounded-circle border border-white"
                                                                                        style={{ width: 30, height: 30 }}
                                                                                    />
                                                                                ) : (
                                                                                    <User size={24} className="text-secondary" />
                                                                                )}

                                                                                <span>{userFullName(item?.user || item)}</span>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </ListGroup.Item>
                                                    ))}
                                                </ListGroup>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>}
                </Container>
            </section>
        </>
    );
};

export default WorkshopView;
